import React from "react";
import { Text, View } from "react-native";
import { Select } from "../ui/select";
import { Id } from "@teachloop/backend/_generated/dataModel";
import { LessonQuantities } from "@/elements/hooks/use-lesson-quantities";

type LessonTypeQuantitySelectorProps = {
  studentId: Id<"students">;
  lessonQuantities: LessonQuantities;
  inPersonLessonCreditsForSelectedStudent: number;
  remoteLessonCreditsForSelectedStudent: number;
  onOpenLessonCountSelectSheet: (mode: "inPerson" | "remote", currentValue: number) => void;
};

function LessonTypeQuantitySelector({
  studentId,
  lessonQuantities,
  inPersonLessonCreditsForSelectedStudent,
  remoteLessonCreditsForSelectedStudent,
  onOpenLessonCountSelectSheet,
}: LessonTypeQuantitySelectorProps) {
  const inPersonLessonQuantity = lessonQuantities[studentId].inPerson ?? 0;
  const remoteLessonQuantity = lessonQuantities[studentId].remote ?? 0;

  return (
    <View className="gap-4">
      <View className="flex-row justify-between">
        <Text className="text-base font-geologica-medium font-medium text-black leading-[1.5]">
          Lesson type
        </Text>
        <Text className="text-base font-geologica-medium font-medium text-black leading-[1.5]">
          Nr of lessons
        </Text>
        <Text className="text-base font-geologica-medium font-medium text-black leading-[1.5]">
          Nr of credits
        </Text>
      </View>
      <View className="flex-row justify-between items-center">
        <View className="flex-1">
          <Text className="text-base font-geologica-regular font-normal text-black leading-[1.5]">
            In-person
          </Text>
        </View>
        <View className="flex-1">
          <Select
            onPress={() => {
              onOpenLessonCountSelectSheet("inPerson", inPersonLessonQuantity);
            }}
            size="md"
          >
            <Select.Label>{inPersonLessonQuantity}</Select.Label>
            <Select.DownArrow />
          </Select>
        </View>
        <View className="flex-1">
          <Text className="text-center text-xl font-geologica-regular font-normal text-black leading-[1.5]">
            {inPersonLessonCreditsForSelectedStudent * inPersonLessonQuantity}
          </Text>
        </View>
      </View>
      <View className="flex-row justify-between items-center">
        <View className="flex-1">
          <Text className="text-base font-geologica-regular font-normal text-black leading-[1.5]">
            Remote
          </Text>
        </View>
        <View className="flex-1">
          <Select
            onPress={() => {
              onOpenLessonCountSelectSheet("remote", remoteLessonQuantity);
            }}
            size="md"
          >
            <Select.Label>{remoteLessonQuantity}</Select.Label>
            <Select.DownArrow />
          </Select>
        </View>
        <View className="flex-1">
          <Text className="text-center text-xl font-geologica-regular font-normal text-black leading-[1.5]">
            {remoteLessonCreditsForSelectedStudent * remoteLessonQuantity}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default LessonTypeQuantitySelector;
